import React from "react";
import { FaCarSide } from "react-icons/fa";

const Loading = ({ message }) => {
  return (
    <div className="loader">
      <h1>
        <FaCarSide />
      </h1>
      <h1>
        <span>{message}</span>

        <span className="bullets">.</span>
      </h1>
    </div>
  );
};

export default Loading;
